import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  Typography,
} from "antd";
import React, { FC, useEffect } from "react";
import styled from "@emotion/styled";
import locale from "antd/es/date-picker/locale/th_TH";
import SettingAvatar from "./SettingAvatar";

interface SettingMyProfileFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  avatar: any;
}

const SettingMyProfileForm: FC<SettingMyProfileFormProps> = ({
  form,
  onFinish,
  avatar,
}) => {
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 24 }}
      >
        <Row justify={"center"}>
          <SettingAvatar />
        </Row>
        <Row justify={"center"} style={{ marginBottom: 20 }}>
          <Typography.Text>รูปโปรไฟล์</Typography.Text>
        </Row>

        <Form.Item
          name="first_name"
          labelAlign="left"
          label="ชื่อ"
          rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="last_name"
          labelAlign="left"
          label="นามสกุล"
          rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
        >
          <Input />
        </Form.Item>
        {/* <Form.Item
          name="card_id"
          labelAlign="left"
          label="หมายเลขบัตรประชาชน"
          rules={[{ required: true, message: "กรุณากรอกหมายเลขบัตรประชาชน" }]}
        >
          <Input />
        </Form.Item> */}
        <Form.Item
          name="mobile"
          labelAlign="left"
          label="เบอร์โทรศัพท์"
          rules={[{ required: true, message: "กรุณากรอกเบอร์โทรศัพท์" }]}
        >
          <Input disabled={true} />
        </Form.Item>
        <Form.Item
          name="email"
          labelAlign="left"
          label="อีเมล"
          rules={[{ required: false, message: "กรุณากรอกอีเมล" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="gender"
          labelAlign="left"
          label="เพศ"
          rules={[{ required: false, message: "กรุณาเลือกเพศ" }]}
        >
          <Select
            showSearch
            size="large"
            placeholder="เลือกเพศ"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={[
              {
                value: "ชาย",
                label: "ชาย",
              },
              {
                value: "หญิง",
                label: "หญิง",
              },
              {
                value: "อื่นๆ",
                label: "อื่นๆ",
              },
            ]}
          />
        </Form.Item>
        <Form.Item
          name="birth_date"
          labelAlign="left"
          label="วันเกิด"
          rules={[{ required: false, message: "กรุณากรอกวันเกิด" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format={"YYYY-MM-DD"}
            size="large"
          />
        </Form.Item>
        <Form.Item>
          <WrapperButton>
            <Button
              style={{ width: 250 }}
              type="primary"
              size="large"
              htmlType="submit"
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default SettingMyProfileForm;

const WrapperAvata = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  width: 130px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;
